"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.KnowledgeBaseArticleService = void 0;
const service_1 = require("@phishtool/service");
const knowledge_base_article_1 = __importDefault(require("~controllers/service/knowledge-base-article"));
class KnowledgeBaseArticleService extends service_1.Service {
    constructor() {
        super(...arguments);
        this.useGetKnowledgeBaseArticle = this.addSingletonQuery({
            controller: knowledge_base_article_1.default,
            opts: {
                staleTime: Infinity,
            },
        });
    }
}
exports.KnowledgeBaseArticleService = KnowledgeBaseArticleService;
